import styled from "styled-components";

const Label = styled.label`
  margin-bottom: 0.25rem;
`;

export default Label;
